import React, { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Button } from 'antd'
import FooterButtons from '../../common/components/FooterButtons'
import { RnExercise } from '../rnSlice'
import { getLevels } from '../rnHelper'

export interface IRnLevelChooserProps {
  hidden?: boolean
  exercises: RnExercise[]
  pickLevel: (level: number) => void
}

const RnLevelChooser = ({hidden, exercises, pickLevel}: IRnLevelChooserProps) => {
  const [level, setLevel] = useState<number | undefined>(undefined)

  if (hidden) { return null }

  const readyToSubmit = level !== undefined

  const handleNext = () => {
    if (readyToSubmit) {
      pickLevel(level!)
      setLevel(undefined)
    }
  }

  const levelCols = getLevels(exercises).map((exerciseLevel) => {   
    const buttonType = exerciseLevel === level ? 'primary' : 'default'
    return (
      <Col xs={12} sm={6} md={3} key={`level-${exerciseLevel}`}>
        <Button size="large" block type={buttonType} onClick={() => setLevel(exerciseLevel)}>Level {exerciseLevel}</Button>
      </Col>
    )
  })

  return (
    <>
      <Container>
        <h5 className="mt-4">Choose Level</h5>
        <Row>
          {levelCols}
        </Row>
      </Container>
      <FooterButtons 
        buttons={[{ disabled: !readyToSubmit, label: "Next", action: handleNext, buttonType: "primary" }]}
      />
    </>
  )
}

export default RnLevelChooser